import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import localforage from 'localforage';
import memoryDriver from 'localforage-memoryStorageDriver';
import { history } from './redux/configureStore';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import 'popper.js';
import 'hammerjs';
import { library } from '@fortawesome/fontawesome-svg-core';

import { auth0Config } from './appConfig';
import { Auth0Provider } from '@auth0/auth0-react';
import {
  faBars,
  faSignOutAlt,
  faList,
  faExclamationTriangle,
  faAngleLeft,
  faAngleRight,
  faInfoCircle,
  faSyncAlt,
} from '@fortawesome/free-solid-svg-icons';
import Root from './components/Root';
import './styles/general.scss';
import './styles/kendoOverWrite.scss';
import './favicon.png';
import AuthBootstrap from './components/login/authBootstrap';

(async function init(): Promise<void> {
  await localforage.defineDriver(memoryDriver);

  library.add(
    faBars,
    faSignOutAlt,
    faList,
    faExclamationTriangle,
    faAngleLeft,
    faAngleRight,
    faInfoCircle,
    faSyncAlt,
  );

  const onRedirectCallback = (appState: any) => {
    if (appState?.returnTo) {
      history.replace(appState.returnTo);
    }
  };

  const providerConfig = {
    domain: auth0Config.domain,
    clientId: auth0Config.clientId,
    onRedirectCallback,
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: auth0Config.audience,
      scope: 'openid profile email offline_access',
    },
    useRefreshTokens: true,
    useRefreshTokensFallback: true,
    cacheLocation: 'localstorage' as const,
  };

  render(
    <Auth0Provider {...providerConfig}>
      <AppContainer>
        <PersistGate loading={null} persistor={persistor}>
          <AuthBootstrap />
          <Root store={store} history={history} />
        </PersistGate>
      </AppContainer>
    </Auth0Provider>,

    document.getElementById('app'),
  );

  if (module.hot) {
    module.hot.accept('./components/Root', () => {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const NewRoot = require('./components/Root').default;
      render(
        <AppContainer>
          <PersistGate loading={null} persistor={persistor}>
            <NewRoot store={store} history={history} />
          </PersistGate>
        </AppContainer>,
        document.getElementById('app'),
      );
    });
  }
})();
